import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP002_Request,
  IAPI_APP002_Response,
  IAPI_APP013_Request,
  IAPI_APP013_Response,
  IAPI_APP014_Request,
  IAPI_APP014_Response,
  IAPI_APP017_Request,
  IAPI_APP017_Response,
} from "../../../type/apiType";

/**
 * 法人ホーム表示API
 * @return httpAPI_APP017
 */
const httpAPI_APP017 = async (
  param: IAPI_APP017_Request
): Promise<IAPI_APP017_Response> => {
  const res = await http.post(ApiUrl.API_APP017, {
    ...param,
  });

  return res.data;
};

/**
 * 手続履歴状態更新API
 * @return httpAPI_APP002
 */
const httpAPI_APP002 = async (
  param: IAPI_APP002_Request
): Promise<IAPI_APP002_Response> => {
  const res = await http.post(ApiUrl.API_APP002, {
    ...param,
  });

  return res.data;
};

/**
 * 掛金届の再提出API
 * @return httpAPI_APP013
 */
const httpAPI_APP013 = async (
  param: IAPI_APP013_Request
): Promise<IAPI_APP013_Response> => {
  const res = await http.post(ApiUrl.API_APP013, {
    ...param,
  });

  return res.data;
};

/**
 * 共済法令違反による契約解除に対する従業状況更新API
 * @return httpAPI_APP014
 */
const httpAPI_APP014 = async (
  param: IAPI_APP014_Request
): Promise<IAPI_APP014_Response> => {
  const res = await http.post(ApiUrl.API_APP014, {
    ...param,
  });

  return res.data;
};

export { httpAPI_APP002, httpAPI_APP013, httpAPI_APP014, httpAPI_APP017 };
